import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'

interface AddButton {
  uri: string;
  testId?: string;
  onClick?: (eventevent: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  children: React.ReactNode;
}

const AddButton = ({ uri, children, testId = '', ...props }: AddButton) => ( // TODO: rename to AddLink
  <S.Link {...props} to={uri} data-testid={testId} onClick={(event) => {
    event.stopPropagation()
    if (props.onClick) { props.onClick(event) }
  }}
  >
    <KeyboardAccessible>
      <S.PlusIcon className="icon-plus" />
      {children}
    </KeyboardAccessible>
  </S.Link>
)

export default AddButton

const S = {
  Link: styled(NavLink)`
    float: right;
    text-transform: capitalize;
    font-weight: 700;
  `,
  PlusIcon: styled.span`
    position: relative;
    top: 2px;
  `
}
